"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function makeExtension(snackbarMessages) {
    return {
        views: {
            get snackbarMessages() {
                return snackbarMessages;
            },
        },
        actions: {
            notify(message, level, action) {
                this.pushSnackbarMessage(message, level, action);
                if (level === 'info' || level === 'success') {
                    setTimeout(() => {
                        this.removeSnackbarMessage(message);
                    }, 5000);
                }
            },
            pushSnackbarMessage(message, level, action) {
                return snackbarMessages.push([message, level, action]);
            },
            popSnackbarMessage() {
                return snackbarMessages.pop();
            },
            removeSnackbarMessage(message) {
                const element = snackbarMessages.find(f => f[0] === message);
                if (element) {
                    snackbarMessages.remove(element);
                }
            },
        },
    };
}
function addSnackbarToModel(tree) {
    return tree.extend(() => {
        const snackbarMessages = mobx_1.observable.array();
        return makeExtension(snackbarMessages);
    });
}
exports.default = addSnackbarToModel;
